import {normalizePath} from './pathUtil';
const appConfig = require('../data.json');

// 不套用全站 Layout（PageContainer）的頁面。
// 一律以「帶尾斜線」形式列出，對齊 gatsby-config 的 trailingSlash: 'always'。
//
// 白牌調整：原本硬編碼 ['/designs/', '/business/']，改為依 config 決定——
// - `/designs/`（編輯器）：跟隨 config.enableEditor，關閉時 gatsby-node 也不建該路由
// - `/business/`（企業專區）：不供白牌，src/Templates/Business/ 未納入本 repo
//   （客戶若要，複製該目錄、補回 gatsby-node 建頁，並在此加回 '/business/'）
const NO_LAYOUT_PATHS = [...(appConfig.enableEditor ? ['/designs/'] : [])];

// 判斷某路徑是否屬於 no-layout 頁面。
//
// 關鍵：SSR 階段 wrapPageElement 收到的 props.path 是 createPage 的原始路徑
// （例如 '/designs'，無尾斜線），但 client 端正規化後是 '/designs/'。若直接用
// 原始字串比對，server 會套 Layout、client 不套，造成 hydration 結構不一致
// （React #418 → #423）。故先 normalizePath 補上尾斜線再比對，讓兩端結果一致。
const isNoLayoutPath = (path) => {
  if (!path) return false;
  return NO_LAYOUT_PATHS.includes(normalizePath(path));
};

export {NO_LAYOUT_PATHS, isNoLayoutPath};
